export default __webpack_public_path__ + "f6050d40b49ae029c9812a720a39201c.png";